module.exports = __webpack_public_path__ + "static/assets/7130491bf33852e50503dcb4024c0279.svg";